import axios from '../../utils/http'
import {
    post,
    get,
    put,
    axiosDelete,
    getExcel
} from '../../utils/http'
import XLSX from "xlsx";
//带cookie
//axios.defaults.withCredentials = true;
axios.defaults.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
}


//City
export function getCityAll(FilterText = "", Sorting = 'id ASC', MaxResultCount = 50, SkipCount = 0) {
    return get(`/api/services/app/City/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function getCityAlls() {
    return get(`/api/services/app/City/GetAll`);
}

export function addCity(data) {
    return post(`/api/services/app/City/Create`, data);
}

export function editCity(data) {
    return put(`/api/services/app/City/Update`, data);
}

export function deleteCity(data) {
    return axiosDelete(`/api/services/app/City/Delete`, data)
}

export function GetCityList() {
    return get(`/api/services/app/City/GetCityList`)
}

// CommonService
export function GetDBRepAPIUrlInfo() {
    return get(`/api/services/app/CommonService/GetDBRepAPIUrlInfo`)
}
export function odataElectricQuantity() {
    return get(`https://seelabinteface.chinacloudsites.cn/odata/ElectricQuantity`)
}

export function CreateNextYearElectricPrice(data) {
    return post(`/api/services/app/ElectricPrice/CreateNextYearElectricPrice?year=${data}`)
}

//DwDataService
export function GetCurveData(data) {
    return get(`/api/services/app/DwDataService/GetCurveData?DeviceCode=${data.deviceCode}&DeviceId=${data.deviceId}`)
}

export function GetHumCurveData(data) {
    return get(`/api/services/app/DwDataService/GetHumCurveData?DeviceCode=${data.deviceCode}&DeviceId=${data.deviceId}`)
}

export function GetElectricQuantityData(datas) {
    return get(`/api/services/app/DwDataService/GetElectricQuantityData?CityID=${datas.cityID}&FactoryID=${datas.factoryID}`)
}

export function GetEqPueData(datas) {
    return get(`/api/services/app/DwDataService/GetEqPueData?LabId=${datas.labId}`)
}

export function GetKpiData(datas) {
    return get(`/api/services/app/DwDataService/GetKpiData?LabId=${datas.labId}`)
}

export function GetRealPueData(datas) {
    return get(`/api/services/app/DwDataService/GetRealPueData?LabId=${datas.labId}`)
}


//department
export function GetAllDepartment() {
    return get(`/api/services/app/Department/GetAll?MaxResultCount=1000`);
}

//电表聚合表示配置
export function GetAllEcFlagConfig() {
    return get(`/api/services/app/ElectricCollectionFlag/GetAll?MaxResultCount=1000`);
}
//eletricityInfo
export function GetAllElectricInfo(data) {
    return get(`/api/services/app/ElectricInfo/GetAll?sorting=id&MaxResultCount=10&SkipCount=${data.currentPage}&CityId=${data.cityId}&FactoryId=${data.factoryId}&BuildingId=${data.buildingId}&LabId=${data.LabId}&DeviceName=${data.DeviceName}`);
}

export function createElectric(data) {
    return post(`/api/services/app/ElectricInfo/Create`, data);
}

export function updateElectric(data) {
    return put(`/api/services/app/ElectricInfo/Update`, data);
}

export function DeleteElectric(data) {
    return axiosDelete(`/api/services/app/ElectricInfo/Delete`, data);
}

export function BatchDeleteElectric(data) {
    return post(`/api/services/app/ElectricInfo/BatchDelete`, data);
}

//ElectricPrice
export function GetAllElectricPrice(data) {
    return get(`/api/services/app/ElectricPrice/GetAll?sorting=endDate&MaxResultCount=10&SkipCount=${data.currentPage}&FactoryName=${data.factoryName}`);
}

export function CreateElectricPrice(data) {
    return post(`/api/services/app/ElectricPrice/Create`, data);
}

export function UpdateElectricPrice(data) {
    return put(`/api/services/app/ElectricPrice/Update`, data);
}

export function DeleteElectricPrice(data) {
    return axiosDelete(`/api/services/app/ElectricPrice/Delete?Id=${data}`);
}

//StopElectric
export function CreateStopElectric(data) {
    return post(`/api/services/app/StopElectric/Create`, data);
}

export function GetAllStopElectric(data) {
    return get(`/api/services/app/StopElectric/GetAll?sorting=id&MaxResultCount=10&SkipCount=${data.currentPage}&FilterText=${data.FilterText}&CityId=${data.cityId}&BuildingId=${data.buildingId}&FactoryId=${data.factoryId}&LabId=${data.LabId}&DeviceId=${data.DeviceId}&startTime=${data.startTime}&EndTime=${data.EndTime}`);
}

export function UpdateStopElectric(data) {
    return put(`/api/services/app/StopElectric/Update`, data);
}

export function DeleteStopElectric(data) {
    return axiosDelete(`/api/services/app/StopElectric/Delete?Id=${data}`);
}


//FactoryMonthUsageService
export function GetComprehensiveTypes() {
    return get(`/api/services/app/ComprehensiveSet/GetComprehensiveTypes`);
}

export function GetAllFactoryMonthUsageService(data) {
    return get(`/api/services/app/FactoryMonthUsageService/GetAll?sorting=&MaxResultCount=10&SkipCount=${data.currentPage}&FilterText=${data.filterText}&CityId=${data.cityId}&FactoryId=${data.factoryId}`);
}

export function CreateFactoryMonthUsageService(data) {
    return post(`/api/services/app/FactoryMonthUsageService/Create`, data);
}

export function UpdateFactoryMonthUsageService(data) {
    return put(`/api/services/app/FactoryMonthUsageService/Update`, data);
}

export function DeleteFactoryMonthUsageService(data) {
    return axiosDelete(`/api/services/app/FactoryMonthUsageService/Delete?Id=${data}`);
}

//FunctionGroup
export function GetAllFunctionGroup(data) {
    return get(`/api/services/app/FunctionGroup/GetAll`);
}

//function
export function GetAllFunction(data) {
    return get(`/api/services/app/Function/GetAll`);
}

//ComprehensiveSet
export function GetAllComprehensiveSet(data) {
    return get(`/api/services/app/ComprehensiveSet/GetAll?sorting=&MaxResultCount=10&SkipCount=${data.currentPage}&FilterText=${data.FilterText}&Name=${data.name}&TypeCode=${data.typeCode}`);
}

export function CreateComprehensiveSet(data) {
    return post(`/api/services/app/ComprehensiveSet/Create`, data);
}

export function UpdateComprehensiveSet(data) {
    return put(`/api/services/app/ComprehensiveSet/Update`, data);
}

export function DeleteComprehensiveSet(data) {
    return axiosDelete(`/api/services/app/ComprehensiveSet/Delete?Id=${data.id}&TypeCode=${data.TypeCode}`);
}

//getMobile
export function GetCreateLabInital() {
    return get(`/api/services/app/Laboratory/GetCreateLabInital`);
}

//IOT设备管理
export function GetAllIoTDevice(data) {
    return get(`/api/services/app/IoTDevice/GetAll?sorting=id&MaxResultCount=${data.maxResultCount}&SkipCount=${data.currentPage}&CityId=${data.cityId}&FactoryId=${data.factoryId}&BuildingId=${data.buildingId}&LabId=${data.LabId}&DeviceName=${data.DeviceName}`);
}

export function createIoTDevice(data) {
    return post(`/api/services/app/IoTDevice/Create`, data);
}

export function updateIoTDevice(data) {
    return put(`/api/services/app/IoTDevice/Update`, data);
}

export function DeleteIoTDevice(data) {
    return axiosDelete(`/api/services/app/IoTDevice/Delete`, data);
}

export function BatchDeleteIoTDevice(data) {
    return post(`/api/services/app/IoTDevice/BatchDelete`, data);
}

export function getIoTDeviceTypes() {
    return get(`/api/services/app/IoTDevice/GetIoTDeviceTypes`);
}

//otherDevice
// export function GetAllOtherDevice(data) {
//     return get(`/api/services/app/OtherDevice/GetAll?sorting=id&MaxResultCount=10&SkipCount=${data.currentPage}&CityId=${data.cityId}&FactoryId=${data.factoryId}&BuildingId=${data.buildingId}&LabId=${data.LabId}&DeviceName=${data.DeviceName}`);
// }

export function GetAllOtherDevice(data) {
    return post(`/api/services/app/OtherDevice/QueryAll`, data);
}

export function createOtherDevice(data) {
    return post(`/api/services/app/OtherDevice/Create`, data);
}

export function updateOtherDevice(data) {
    return put(`/api/services/app/OtherDevice/Update`, data);
}

export function DeleteOtherDevice(data) {
    return axiosDelete(`/api/services/app/OtherDevice/Delete`, data);
}

export function BatchDeleteOtherDevice(data) {
    return post(`/api/services/app/OtherDevice/BatchDelete`, data);
}

export function getOtherDeviceTypes() {
    return get(`/api/services/app/OtherDevice/GetOtherDeviceTypes`);
}


//Embed,powerbi嵌入报表接口
export function getEmbedInfo(data) {
    return post(`/api/services/app/O365Service/GetEmbedInfo`, data);
}


//Factory
export function getFactoryAll(BuildingName = "", FactoryId = "", CityId = "", FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
    return get(`/api/services/app/Building/GetAll?&BuildingName=${BuildingName}&FactoryId=${FactoryId}&CityId=${CityId}&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function getFactoryAlls() {
    return get(`/api/services/app/Factory/GetAll`);
}

export function getFactoryByName(data) {
    return get(`/api/services/app/Factory/GetByName?factoryName=${data}`);
}

export function GetByCityId(cityId) {
    return get(`/api/services/app/Factory/GetByCityId?cityId=${cityId}`);

}

export function addFactory(data) {
    return post(`/api/services/app/Factory/Create`, data)
}

export function editFactory(data) {
    return put(`/api/services/app/Factory/Update`, data);
}

export function deleteFactory(data) {
    return axiosDelete(`/api/services/app/Factory/Delete`, data)
}

//configInfo
export function getFormulaAll(FilterText = "", Sorting = 'id ASC', MaxResultCount, SkipCount = 0, FactoryCode) {
    return get(`/api/services/app/Formula/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}&FactoryCode=${FactoryCode}`);
}

export function FormulaCreate(data) {
    return post(`/api/services/app/Formula/Create`, data);
}

export function FormulaUpdate(data) {
    return put(`/api/services/app/Formula/Update`, data);
}

export function FormulaDelete(data) {
    return axiosDelete(`/api/services/app/Formula/Delete?Id=${data}`);
}


//Building
export function GetByFactoryId(FactoryId) {
    return get(`/api/services/app/Building/GetByFactoryId?factoryId=${FactoryId}`)
}

export function addBuilding(data) {
    return post(`/api/services/app/Building/Create`, data)
}

//Floor
export function GetByBuildingId(BuildingId) {
    return get(`/api/services/app/Floor/GetByBuildId?buildId=${BuildingId}`)
}

export function GetAllBuilding(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
    return get(`/api/services/app/Building/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`)
}

export function editFloor(data) {
    return put(`/api/services/app/Building/UpdateBuildingFloor`, data)
}

export function GetBuildingAlls() {
    return get(`/api/services/app/Building/GetAll`)
}

export function deleteBuilding(data) {
    return axiosDelete(`/api/services/app/Building/Delete`, data)
}

//menu
export function CreateMenu(data) {
    return post(`/api/services/app/Menu/CreateMenu`, data)
}

export function GetAllMenus(data) {
    return get(`/api/services/app/Menu/GetAllMenus`)
}

export function GetAllMenus1(data) {
    return get(`/api/services/app/Menu/GetAllMenus1`)
}

export function AddMenuToRole(data) {
    return post(`/api/services/app/Menu/AddMenuToRole`, data)
}

export function DeleteMenu(data) {
    return axiosDelete(`/api/services/app/Menu/Delete`, data)
}

export function UpdateMenu(data) {
    return put(`/api/services/app/Menu/Update`, data)
}

export function GetMenus(data) {
    return get(`/api/services/app/Menu/GetMenus`)
}

export function GetUserMenu() {
    return get(`/api/services/app/Menu/GetUserValidMenu`)
}


//RegionService

export function GetAllRegionChainList() {
    return get(`/api/services/app/RegionService/GetAllRegionChainList`)
}
export function GetMyRegionChainList() {
    return get(`/api/services/app/RegionService/GetMyRegionChainList`)
}

//NotificationThreshold
export function GetAllNotification(data, Sorting = 'id ASC', MaxResultCount, SkipCount = 0) {
    return get(`/api/services/app/NotificationThreshold/GetAll?&CityId=${data.cityId}&DeviceType=${data.deviceType}&BuildingId=${data.buildingId}&FactoryId=${data.factoryId}&LabId=${data.LabId}&DeviceId=${data.deviceId}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`)
}

export function CreateNotification(data) {
    return post(`/api/services/app/NotificationThreshold/Create`, data)
}

export function DeleteNotification(data) {
    return axiosDelete(`/api/services/app/NotificationThreshold/Delete?Id=${data}`)
}

export function UpdateNotification(data) {
    return put(`/api/services/app/NotificationThreshold/Update`, data)
}

export function GetAllLabNoitif(data) {
    return get(`/api/services/app/NotificationRecords/GetAllLabNoitifNew?CityId=${data.cityId}&FactoryId=${data.factoryId}&BuildingId=${data.buildingId}&LabId=${data.LabId}&MaxResultCount=${100}`)
}
//ManualInputService
export function GetAllManualInputService(data, MaxResultCount, SkipCount = 0) {
    return get(`/api/services/app/ManualInputService/GetAll?DeviceType=${data.deviceType}&InputType=${data.inputType}&DeviceId=${data.deviceId}&DeviceCode=${data.deviceCode}&BillNumber=${data.billNumber}&YearMonth=${data.yearMonth}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`)
}
export function GetByDeviceId(data) {
    return get(`/api/services/app/ManualInputService/GetByDeviceId?DeviceCode=${data.code}&YearMonth=${data.yearMonth}&InputType=${data.inputType}&CurValueDate=${data.curValueDate}`)
}

export function CreateManualInputService(data) {
    return post(`/api/services/app/ManualInputService/Create`, data)
}

export function DeleteManualInputService(data) {
    return axiosDelete(`/api/services/app/ManualInputService/Delete?Id=${data}`)
}

export function UpdateManualInputService(data) {
    return put(`/api/services/app/ManualInputService/Update`, data)
}


//NotificationRecords
export function GetNotifCount(data) {
    return get(`/api/services/app/NotificationRecords/GetNotifCount?&CityId=${data.cityId}&FactoryId=${data.factoryId}`)
}
export function GetAllNotificationRecords(data, Sorting = 'id ASC', MaxResultCount, SkipCount = 0) {
    return get(`/api/services/app/NotificationRecords/GetAll?&CityId=${data.cityId}&BeginDate=${data.startTime}&EndDate=${data.endTime}&BuildingId=${data.buildingId}&FactoryId=${data.factoryId}&LabId=${data.LabId}&QueryString=${data.queryString}&RecordsType=${data.recordsType}&DealType=${data.dealType}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}&SystemAlarmTimestartTime=${data.SystemAlarmTimestartTime}&SystemAlarmTimeendTime=${data.SystemAlarmTimeendTime}&processTimestartTime=${data.processTimestartTime}&processTimeendTime=${data.processTimeendTime}&DeviceType=${data.deviceType}&levelGroupId=${data.levelGroupId}`)

}
export function UpdateNotificationRecords(data) {
    return put(`/api/services/app/NotificationRecords/Update`, data)
}

// export function ExportNotificationData(data, Sorting = 'id ASC', MaxResultCount, SkipCount = 0) {
//     return getExcel(`/api/services/app/ExportAlarmExcelService/GetAlarmExcel?&CityId=${data.cityId}&BeginDate=${data.startTime}&EndDate=${data.endTime}&BuildingId=${data.buildingId}&FactoryId=${data.factoryId}&LabId=${data.LabId}&QueryString=${data.queryString}&RecordsType=${data.recordsType}&DealType=${data.dealType}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`)
// }

export function ExportNotificationData(data, Sorting = 'id ASC', MaxResultCount, SkipCount = 0) {
    return get(`/api/services/app/ExportAlarmExcelService/GetAlarmExcel?&CityId=${data.cityId}&BeginDate=${data.startTime}&EndDate=${data.endTime}&BuildingId=${data.buildingId}&FactoryId=${data.factoryId}&LabId=${data.LabId}&QueryString=${data.queryString}&RecordsType=${data.recordsType}&DealType=${data.dealType}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}&SystemAlarmTimestartTime=${data.SystemAlarmTimestartTime}&SystemAlarmTimeendTime=${data.SystemAlarmTimeendTime}&processTimestartTime=${data.processTimestartTime}&processTimeendTime=${data.processTimeendTime}&DeviceType=${data.deviceType}`)
}
//Laboratory
export function getLabAll(LabName = "", BuildingId = "", FactoryId = "", CityId = "", FilterText = "", Sorting = 'id ASC', SpaceID = '', MaxResultCount = 6, SkipCount = 0) {

    return get(`/api/services/app/Laboratory/GetAll?SpaceID=${SpaceID}&LabName=${LabName}&BuildingId=${BuildingId}&FactoryId=${FactoryId}&CityId=${CityId}&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function getLabAlls() {
    return get(`/api/services/app/Laboratory/GetAll`);
}

export function GetLabByBuildingId(buildingId) {
    return get(`/api/services/app/Laboratory/GetByBuildingId?buildingId=${buildingId}`)
}

export function editLab(data) {
    return put(`/api/services/app/Laboratory/Update`, data);
}

export function deleteLab(data) {
    return axiosDelete(`/api/services/app/Laboratory/Delete`, data)
}

export function addLab(data) {
    return post(`/api/services/app/Laboratory/Create`, data)
}

export function getLabScreenInfo(labId) {
    return get(`/api/services/app/Laboratory/GetLabScreenInfo?LabID=${labId}`)
}

export function GetAllLabInfoList(data) {
    return get(`/api/services/app/Laboratory/GetAllLabInfoList?CityId=${data.cityId}&FactoryId=${data.factoryId}&BuildingId=${data.buildingId}&LabId=${data.LabId}`)
}

//Device
export function getDeviceByLabId(LabId = "") {
    return get(`/api/services/app/ElectricInfo/GetByLabId?&LabId=${LabId}`);
}

export function getElectricInfoById(Id = "") {
    return get(`/api/services/app/ElectricInfo/GetByDeviceId?&input=${Id}`);
}

export function GetByDeviceTypeCode(data) {
    return get(`/api/services/app/Device/GetByDeviceTypeCode`, data);
}

export function GetByDeviceCode(data) {
    return get(`/api/services/app/Device/GetByDeviceCode?&Id=${data}`);
}

//温湿度
export function getOtherDeviceByLabId(LabId = "") {
    return get(`/api/services/app/OtherDevice/GetTemHumSensorByLabId?&labId=${LabId}`);
}

export function GetAllDevice() {
    return get(`/api/services/app/Device/GetAll`);
}

//Role_set
export function getRoles(roleName) {
    return get(`/api/services/app/Role/GetRoles?&Permission=${roleName}`)
}

export function addRoles(data) {
    return post(`/api/services/app/Role/Create`, data)
}

export function updateRoles(data) {
    return put(`/api/services/app/Role/Update`, data)
}

export function UpdateRoleDataPermissionList(data) {
    return put(`/api/services/app/Role/UpdateRoleDataPermissionList`, data)
}

export function deleteRole(id) {
    return axiosDelete(`/api/services/app/Role/Delete?id=${id}`)
}

export function getAllRoles(Keyword = "", SkipCount = 0, MaxResultCount = 0) {
    return get(`/api/services/app/Role/GetAll?Keyword=${Keyword}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}

export function getAllRole() {
    return get(`/api/services/app/Role/GetAll?MaxResultCount=10000`)
}

export function GetUserDatapermission(data) {
    return get(`/api/services/app/Role/GetUserDatapermission?UserId=${data}`)
}

export function GetUserRoleDatapermission(data) {
    return get(`/api/services/app/Role/GetUserRoleDatapermission?UserId=${data.UserId}&RoleId=${data.RoleId}`)
}

export function GetUserRoleListDatapermission(data) {
    return get(`/api/services/app/Role/GetUserRoleListDatapermission?UserId=${data}`)
}

export function GetMyListDatapermission() {
    return get(`/api/services/app/Role/GetMyListDatapermission`)
}

export function GetAllPermissions() {
    return get(`/api/services/app/Role/GetAllPermissions`)
}

export function RolePermissionSet(data) {
    return post(`/api/services/app/Role/RolePermissionSet`, data)
}

export function getAllpermissionMenu() {
    return get(`/api/services/app/Role/GetAllPermissionMenu`)
}

//User
export function getUser(Keyword = "", RoleId = 0, IsActive = true, SkipCount = 0, MaxResultCount = 0) {
    return get(`/api/services/app/User/GetAll?Keyword=${Keyword}&RoleId=${RoleId}&IsActive=${IsActive}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}

export function addUser(data) {
    return post(`/api/services/app/User/Create`, data)
}
export function ResetPassword(data) {
    return post(`/api/services/app/User/ResetPassword`, data)
}

export function UpdateUser(data) {
    return put(`/api/services/app/User/Update`, data)
}

export function deleteUser(data) {
    return axiosDelete(`/api/services/app/User/Delete?Id=${data}`)
}

export function ChangeLanguage(data) {
    return post(`/api/services/app/User/ChangeLanguage`, data)
}


//token
export function authenticate(data) {
    return post('/api/TokenAuth/Authenticate', data);
}
//refreshToken
export function refreshToken() {
    return post('/api/TokenAuth/RefreshUserToken');
}

//level
export function getLevel() {
    return get('/api/services/app/Level/GetAllLevel');
}

//告警发微信
export function SendWeChat(data) {
    return post('/api/services/app/CommonService/TestWeChatCardModel', data);
}

export function getAppVersion() {
    return get(`api/TokenAuth/GetAppVersion`);

}

export function GetOutTempData(labId) {
    return get(`/api/services/app/WeatherDataService/GetOutTempData?LabID=${labId}`)
}

export function exportExcelAlarmList(excelData1, fileName) {
    let ws = XLSX.utils.aoa_to_sheet(excelData1)
    let wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, '告警数据')
    XLSX.writeFile(wb, fileName);
}

export function dateFormat(date, format, hours) {
    if (hours == null || hours == "" || hours == undefined)
        hours = 0;
    if (date) {
        date = new Date(date);
        var o = {
            'M+': date.getMonth() + 1, //month
            'd+': date.getDate(), //day
            'H+': date.getHours() + hours, //hour+8小时
            'm+': date.getMinutes(), //minute
            's+': date.getSeconds(), //second
            'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
            'S': date.getMilliseconds() //millisecond
        };
        if (/(y+)/.test(format))
            format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

        for (var k in o)
            if (new RegExp('(' + k + ')').test(format))
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));

        return format;
    } else {
        return "";
    }

}

export function applicationConfiguration(data) {

    return get(`/api/services/app/LocalizationService/GetLangStrings`, data);
}

export function getAllRoleDic() {
    return get(`api/services/app/Role/GetAllRoleDic`);

}